import { ProfileCardConnected } from "PFApp/components/profile_card_connected";
import { useSearchDispatch, useSearchStoreContext } from "PFApp/search/search_context";
import useIsChatEnabled from "PFApp/use_is_chat_enabled";
import { Button } from "PFComponents/button";
import { Stack } from "PFComponents/containers/flex/stack";
import { LoadingDots } from "PFComponents/loading_dots";
import { SEARCH_ACTIONS } from "PFReducers/search_reducer/search_reducer";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import MoreButton from "../parts/more_button";
import EmptyMatches from "./empty_matches";
import css from "./results.module.scss";

const ResultsMatches = () => {
  const dispatch = useSearchDispatch();
  const {
    search: {
      term,
      matches,
      matchesMeta,
      matchesPending,
      matchesPage,
      profilesMeta: { total: totalProfiles }
    }
  } = useSearchStoreContext();
  const { t } = useTranslation("search");

  const isChatEnabled = useIsChatEnabled();
  const scrollTargetRef = useRef();

  if (!matchesMeta.searchId && matches.length === 0 && matchesPending) {
    // only when before any fetch happened
    return <LoadingDots circlesEnabled pageViewEnabled />;
  }

  return (
    <div className={css.root} style={{ opacity: matchesPending ? 0.6 : 1 }} ref={scrollTargetRef}>
      {matches.length === 0 ? (
        <EmptyMatches />
      ) : (
        <>
          {totalProfiles > 0 && (
            <>
              <strong>{t("results.searchingByName")}</strong>
              <p>
                <Button
                  kind="blank"
                  onClick={() => dispatch({ type: SEARCH_ACTIONS.SEARCH_SET_TAB, payload: "profiles" })}
                >
                  {t("results.countFoundProfiles", { count: totalProfiles, term })}
                </Button>
              </p>
            </>
          )}
          <Stack>
            {matches.map((match) => (
              <ProfileCardConnected
                key={match.id}
                tagName={"li"}
                profileResponse={match}
                withChat={isChatEnabled}
              />
            ))}
          </Stack>
          <MoreButton
            isLoading={matchesPending}
            renderedItemsCount={matches.length}
            total={matchesMeta.total || 0}
            handleClick={() => dispatch({ type: SEARCH_ACTIONS.SEARCH_MORE_MATCHES })}
            perPage={10}
            page={matchesPage}
          />
        </>
      )}
    </div>
  );
};

export default ResultsMatches;
